import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button } from '@mui/material';
import { APP_BASE } from '@/lib/api-base';

/**
 * What a page the signed-in user's roles cannot open shows instead of itself.
 *
 * @param home whether the dashboard is open to them; otherwise the button would lead to the same refusal
 */
export function PageNoAccess({ home = true }: { home?: boolean }) {
  return (
    <Box sx={{ maxWidth: 560 }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        <b>You don&apos;t have access to this page.</b> None of your roles includes the permission it needs. Ask your
        Payroll administrator if you need it.
      </Alert>
      {home && <Button variant="outlined" component={RouterLink} to={`${APP_BASE}/`}>Go to the dashboard</Button>}
    </Box>
  );
}
